"use strict";
// @ts-ignore
try {
    self['workbox:core:7.3.0'] && _();
}
catch (e) { }
